export const GLOBAL_STATE = 'userOpenLink'

export const USER_OPEN_LINK = 'link'
export const CHECK_USER_OPEN_LINK = 'checkOpenLink'
export const USER_PUBLIC_INFO = 'userPublicInfo'
